/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { useAppContext } from '@prisjakt/ui-app-context';
import { IconClose } from '@prisjakt/ui/icon';
import { AllFilters } from './components/all-filters';
import { MobileOnly } from 'src/ui/block';
import { Content } from 'src/components/filter-dropdown';
import { getSortOptions } from '../utils';
import { IOfferListFilters } from './types';
import {
  FilterPanelWrapper,
  FiltersDropDown,
  FilterBlocker,
  FilterMobileHeader,
  CloseButton,
  FilterRow,
} from './styles';
import { TitleMediumText } from '@prisjakt/ui/text/variants';

export const OfferListFilters = ({
  visible,
  closeHandler,
  filters,
  onFilterChanged,
  onSortChange,
  currentSorting,
}: IOfferListFilters) => {
  const { t } = useAppContext();

  const renderFilters = () => (
    <FilterPanelWrapper>
      <FilterMobileHeader>
        {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
        <CloseButton onClick={() => closeHandler()}>
          <IconClose />
        </CloseButton>
      </FilterMobileHeader>
      <AllFilters filters={filters} onToggleFilter={onFilterChanged} />
      <MobileOnly>
        <FilterRow $marginTop>
          <TitleMediumText>{t('common', 'sort.title')}</TitleMediumText>
          <Content
            mobileOnly
            onClick={option => {
              onSortChange(option);
            }}
            selected={currentSorting}
            options={getSortOptions(t)}
          />
        </FilterRow>
      </MobileOnly>
    </FilterPanelWrapper>
  );

  if (!visible) {
    return null;
  }

  return (
    <>
      <FilterBlocker onClick={() => closeHandler()} />
      <FiltersDropDown>{renderFilters()}</FiltersDropDown>
    </>
  );
};
